import 'core-js/es6/promise';
import '@babel/polyfill';
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueI18n from 'vue-i18n';

import App from './App';
import store from './store';
import router from './router';
import { getLanguage } from './utils/system';

import geti18nConfig from './plugin/filter/vue-i18n-config';
import VueImageFilter from './plugin/filter/vue-image-filter';
import VueDatetimeFilter from './plugin/filter/vue-datetime-filter';
import VueNumberFilter from './plugin/filter/vue-number-filter';

import LogManager from './module/LogManager';

import Vue2TouchEvents from 'vue2-touch-events';

import gallery from 'img-vuer';

// TODO: get User's language from config
const language = getLanguage();

///////////////////////
// Vue Plugin List
///////////////////////

Vue.use(VueImageFilter);
Vue.use(VueI18n);
Vue.use(VueDatetimeFilter, { locale: language });
Vue.use(VueNumberFilter);
Vue.use(Vue2TouchEvents);
Vue.use(gallery, {
    swipeThreshold: 150, // default 100
    isIndexShow: true, // show image index, default true
    useCloseButton: true, // trigger gallery close with close button, default true
    preload: true // preload images in the same group, default true
});

sync(store, router);

///////////////////////
// Initialize Vue Root App Component
///////////////////////
Vue.config.errorHandler = function(error) {
    //console.error(error);
    store.dispatch('hideLoading');
    LogManager.sendLog(error);
};

new Vue({
    el: '#app',
    i18n: geti18nConfig(language),
    store,
    router,
    render: h => h(App)
});
